module.exports = __webpack_public_path__ + "img/vitra.e6e3fcd5.svg";